import { useEffect } from 'react';
import { useLogger } from '../services/LogService';

export const useXhr = (src, id = "") => {
    const logger = useLogger('useScript');
    useEffect(() => {
        var xhr = new XMLHttpRequest();
        xhr.open("get", src, true);
        xhr.onreadystatechange = function(){
            if (xhr.readyState === 4){
                if (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304)){
                    var script = document.createElement("script");
                    script.type = "text/javascript";
                    script.text = xhr.responseText;
                    script.setAttribute('id', id);
                    document.body.appendChild(script);
                    logger.log('useXhr : '+script.src);
                }
            }
        };
        xhr.send(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [src]);
};
